import React, { useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Box,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import moment from "moment";
import { useIntersection } from "../../Hooks/customHooks";
import { capitalizeFirstLetter } from "utils/generalUtils";
import "../../Sass/Common.scss";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipOrderdate";
import clsx from "clsx";
import useViewport from "../../Hooks/useViewport";
import { ReactComponent as NoteTextIcon } from "../../Assets/Icons/PharmsmartIcon/NoteTextcon.svg";
import { ReactComponent as ModalCloseIcon } from "Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
// const TableLoadMore = React.lazy(() =>
//   import("Components/Common/Table/TableLoadMore")
// );
// const TableCellLoader = React.lazy(() =>
//   import("Components/Common/Table/TableCellLoader")
// );

const useStyle = makeStyles((theme) => ({
  rsDialogMain: {
    [theme.breakpoints.down("1100")]: {
      left: "5% !important",
    },
    [theme.breakpoints.down("1050")]: {
      left: "7% !important",
    },
    [theme.breakpoints.down("1010")]: {
      left: "8% !important",
    },
    [theme.breakpoints.down("1000")]: {
      left: "0% !important",
      "& .MuiPaper-root.MuiPaper-elevation": {
        maxWidth: "75% !important",
      },
    },
  },
  rsTableRow: {
    "&>td": {
      padding: "10px 17px !important",
    },
  },
  tableHead: {
    "&>tr": {
      "&>th": {
        padding: "10px 17px !important",
        whiteSpace: "nowrap",
        "&:first-child": {
          width: "15% !important",
        },
        " &:nth-child(2)": {
          width: "3% !important",
          whiteSpace: "nowrap",
        },
        " &:nth-child(3)": {
          width: "15% !important",
          whiteSpace: "nowrap",
        },
        " &:nth-child(4)": {
          width: "13% !important",
          whiteSpace: "nowrap",
        },
        "&:last-child": {
          width: "8% !important",
          whiteSpace: "nowrap",
        },
      },
    },
    "&>tr": {
      "&>td": {
        // padding: "10px 17px !important",
        // whiteSpace: "nowrap",
        "&:first-child": {
          width: "15% !important",
          minWidth: "350px !important",
        },
        " &:nth-child(2)": {
          width: "3% !important",
        },
        " &:nth-child(3)": {
          width: "15% !important",
          whiteSpace: "nowrap",
        },
        " &:nth-child(4)": {
          width: "13% !important",
          whiteSpace: "nowrap",
        },
        "&:last-child": {
          width: "8% !important",
          whiteSpace: "nowrap",
        },
      },
    },
  },
  // margin: {
  //   padding: "0px 0px !important",
  //   marginTop: "-20px !important",
  //   "&>table": {
  //     borderTop: "1px solid #e0e0e0 !important",
  //     borderBottom: "1px solid #e0e0e0 !important",
  //     borderRight: "1px solid #e0e0e0 !important",
  //   },
  // },
  icon: {
    height: "140px",
    // marginLeft: "30px !important",
    "&>div": {
      "&>div": {
        "&>svg": {
          weight: "50px !important",
          height: "50px !important",
        },
      },
      "&>h2": {
        "&>p": {
          lineHeight: "normal",
        },
      },
    },
  },
  rsMainTitle: {
    marginTop: "-43px !important",
    marginLeft: "13px !important",
  },
  margin: {
    padding: "0px 0px !important",
    marginLeft: "10px",
    marginRight: "10px",
    "&>table": {
      // borderTop: "1px solid #e0e0e0 !important",
      borderTop: "0px !important",
      borderBottom: "1px solid #e0e0e0 !important",
      borderRight: "1px solid #e0e0e0 !important",
    },
  },
  tableContainer: {
    marginBottom: "20px !important",
    // height: "auto !important",
    padding: "0",
    "&>table": {
      "&>tbody": {
        "&>tr": {
          "&>td": {
            "&:first-child": {
              width: "20% !important",
            },
            " &:nth-child(2)": {
              width: "10% !important",
            },
            " &:nth-child(3)": {
              width: "12% !important",
            },
            " &:nth-child(4)": {
              width: "10% !important",
              whiteSpace: "nowrap",
            },
            "&:last-child": {
              width: "8% !important",
              whiteSpace: "nowrap",
            },
          },
        },
      },
    },
  },
  tablePanel: {
    // borderTop: "1px solid #e0e0e0 !important",
    borderBottom: "1px solid #e0e0e0 !important",
    borderRight: "1px solid #e0e0e0 !important",
    "&>thead": {
      "&>tr": {
        "&>th": {
          "&:first-child": {
            borderRight: "0px !important",
          },
          borderTop: "1px solid #e0e0e0 !important",
        },
      },
    },
    "&>tbody": {
      "&>tr": {
        "&>td": {
          "&:first-child": {
            borderRight: "0px !important",
          },
        },
      },
    },
  },
  rsArchived: {
    backgroundColor: "#7BC044 !important",
    borderRadius: "5px",
    width: "fit-content",
    paddingLeft: "10px",
    paddingRight: "10px",
    color: "white",
    fontWeight: "500",
    cursor: "pointer",
  },
  rsDisableArchived: {
    backgroundColor: "rgba(0, 0, 0, 0.12) !important",
    borderRadius: "5px",
    width: "fit-content",
    paddingLeft: "10px",
    paddingRight: "10px",
    color: "#5A687290",
    fontWeight: "500",
    cursor: "pointer",
  },
  rsTable: {
    position: "sticky",
    top: "-20px !important",
    "&>tr": {
      "&>th": {
        padding: "10px 17px !important",
        whiteSpace: "nowrap",
        "&:first-child": {
          borderRight: "0px !important",
          borderTop: "1px solid #e0e0e0 !important",
        },
      },
    },
  },
  rsBox: {
    position: "absolute",
    background: "#ffffff",

    width: "94%",
    margin: "0px",
    padding: "0px",
    top: "81px",
  },
  rsDialog: {
    "&>div:nth-child(3)": {
      "&>div": {
        top: "0px !important",
        maxHeight: "calc(100vh - 140px)",
        maxWidth: "910px",
      },
    },
  },
}));
const PatientHistoryDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    title = "",
    patientHistory,
    getPatientHistoryAction,
    patientMedicationHistoryList,
    handleMediArchive,
    archiveMedi,
  } = props;
  const width = useViewport();
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const patientMedicationHistoryRecordLimit = 20;
  const height =
    patientMedicationHistoryList?.data?.list?.length > 1
      ? "calc(48vh - 200px) !important"
      : "calc(35vh - 200px) !important";

  /** handle close */
  const handleClose = () => {
    setOpen(false);
  };

  /** get data on open  */
  useEffect(() => {
    if (open) {
      getPatientHistoryAction(patientHistory, {
        offset: 0,
        limit: patientMedicationHistoryRecordLimit,
      });
    }
  }, [open]);

  /** set list on entry  */
  useEffect(() => {
    if (open && entry.isIntersecting) {
      if (
        patientMedicationHistoryList?.data?.list?.length !=
        patientMedicationHistoryList?.data?.filterd_record
      ) {
        getPatientHistoryAction(patientHistory, {
          offset: patientMedicationHistoryList?.data?.list?.length,
          limit: patientMedicationHistoryRecordLimit,
        });
      }
    }
  }, [entry]);

  return (
    <>
      <Dialog
        open={open}
        // className="RSxs_modal"
        className={clsx("RSxs_modal", classes.rsDialog)}
        // maxWidth={width > 1000 ? "md" : "sm"}
        maxWidth="md"
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        // className={clsx("dialogMain", classes.rsDialogMain)}
        // className="dialogMain"
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        scroll={"paper"}
      >
        <Grid className={classes.icon}>
          <PrimaryDialogTitle
            handleClose={handleClose}
            title={
              title
              // <PrimaryIcon height="50px" icon={NoteTextcon} color="white" />
            }
            icon={NoteTextIcon}
            className="Rsheading_form"
          />
          {/* <Grid item xs={8} className={classes.rsMainTitle}>
            <Typography color="secondary" medium variant="h3">
              {title}
            </Typography>
          </Grid> */}
        </Grid>
        <DialogContent className={classes.margin}>
          {/* <Grid container columnSpacing={2.5} rowSpacing={3}>
            <Grid
              item
              xs={12}
              sx={{
                "& .MuiTableContainer-root": {
                  maxHeight:
                    patientMedicationHistoryList?.data?.list?.length > 10
                      ? "calc(90vh - 200px) !important"
                      : height,
                },
              }}
            >
            
              <Grid className="common-table"> */}
          {/* <TableHead className={classes.tableHead}>
            <TableRow className={classes.rsTable}>
              <TableCell>DRUG NAME</TableCell>
              <TableCell>QUANTITY</TableCell>
              <TableCell>COLLECTED BY</TableCell>
              <TableCell>ORDER DATE</TableCell>
              <TableCell>COLLECTED AT</TableCell>
            </TableRow>
          </TableHead> */}
          {/* <TableContainer className={classes.tableContainer}> */}
          <Table stickyHeader className={classes.tablePanel}>
            {/* <TableHead className={classes.tableHead}></TableHead> */}
            {/* <TableHead className={classes.tableHead}>
                <TableRow className={classes.rsTable}>
                  <TableCell>DRUG NAME</TableCell>
                  <TableCell>QUANTITY</TableCell>
                  <TableCell>COLLECTED BY</TableCell>
                  <TableCell>ORDER DATE</TableCell>
                  <TableCell>COLLECTED AT</TableCell>
                </TableRow>
              </TableHead> */}
            <Box className={classes.rsBox}></Box>
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.rsTable}>
                <TableCell>DRUG NAME</TableCell>
                <TableCell>QUANTITY</TableCell>
                <TableCell>MARKED ARRIVED BY</TableCell>
                <TableCell>ORDER DATE</TableCell>
                <TableCell>ARRIVED AT</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableHead}>
              {patientMedicationHistoryList?.loading ? (
                <TableCellLoader cells={5} rows={3} />
              ) : patientMedicationHistoryList?.data?.list?.length > 0 ? (
                patientMedicationHistoryList?.data?.list?.map((item, i) => {
                  return (
                    <TableRow className={classes.rsTableRow}>
                      <TableCell>{item?.drug_name}</TableCell>
                      <TableCell>{item?.quantity}</TableCell>
                      <TableCell>
                        {capitalizeFirstLetter(
                          item?.created_by ? item?.created_by : "-"
                        )}
                      </TableCell>
                      <TableCell>
                        {moment(new Date(item?.order_date)).format(
                          "DD-MM-YYYY  "
                        )}
                        &nbsp;
                        {moment(new Date(item?.order_date), "hh:mm A").format(
                          "HH:mm"
                        )}
                      </TableCell>
                      <TableCell>
                        {item?.status !== "collected" ? (
                          <Box
                            className={
                              // item?.status === "archived" &&
                              // item?.is_archived === 1
                              //   ? classes.rsDisableArchived
                              //   : classes.rsArchived
                              item?.status === null
                                ? ""
                                : item?.status === "archived" &&
                                  item?.is_archived === 1
                                ? classes.rsDisableArchived
                                : classes.rsArchived
                            }
                            onClick={() => {
                              if (
                                item?.status === "archived" &&
                                item?.is_archived === 0
                              ) {
                                handleMediArchive(item?.id, "history");
                              }
                            }}
                          >
                            <HtmlTooltipMain
                              title={`${moment(
                                new Date(item?.created_at)
                              ).format("DD-MM-YYYY")} ${` `}   ${moment(
                                new Date(item?.created_at),
                                "hh:mm A"
                              ).format("HH:mm")}`}
                            >
                              {/* {archiveMedi?.loading === true && (
                                  <CircularProgress
                                    color="white"
                                    size="10px"
                                    marginRight="5px"
                                  />
                                )} */}
                              {/* {item?.status === "archived"
                                ? "Archived"
                                : "Unarchived"} */}
                              {item?.status === null
                                ? "-"
                                : item?.status === "archived"
                                ? "Archived"
                                : "Unarchived"}
                            </HtmlTooltipMain>
                          </Box>
                        ) : (
                          <>
                            {item?.created_at !== null ? (
                              <>
                                {moment(new Date(item?.created_at)).format(
                                  "DD-MM-YYYY"
                                )}{" "}
                                &nbsp;
                                {moment(new Date(item?.created_at)).format(
                                  "HH:mm"
                                )}
                              </>
                            ) : (
                              "-"
                            )}
                            {/* {moment(new Date(item?.created_at)).format(
                              "DD-MM-YYYY"
                            )}
                            &nbsp;
                            {moment(
                              new Date(item?.created_at),
                              "hh:mm A"
                            ).format("HH:mm")} */}
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <>
                  <TableRow className={classes.rsTableRow}>
                    <TableCell
                      style={{ borderBottom: `none !important` }}
                      colSpan={5}
                    >
                      <Typography
                        color="secondary"
                        medium
                        variant="h6"
                        textAlign={"center"}
                      >
                        Medication History Not found
                      </Typography>
                    </TableCell>
                  </TableRow>
                </>
              )}
              {patientMedicationHistoryList?.data?.list?.length !=
                patientMedicationHistoryList?.data?.filterd_record && (
                <TableLoadMore setRef={setTarget} />
              )}
            </TableBody>
          </Table>
          {/* </TableContainer> */}
          {/* </TableContainer> */}
          {/* </Grid>
            </Grid> */}
          {/* </Grid> */}
        </DialogContent>
        <DialogActions className="dialogActionBtn">
          <Button
            style={{ marginTop: "20px" }}
            className="BtnGreen"
            variant="contained"
            onClick={handleClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PatientHistoryDialog;
